<div
  class="fixed z-[10000] top-1/2 start-1/2 ltr:-translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2"
  [class.hidden]="!modal().isOpen">
  <div
    [style.width.rem]="modal().width"
    [style.height.rem]="modal().height"
    class="relative rounded-md bg-white shadow-lg p-2xl max-h-[80vh]"
    [class]="modal().modalClass">
    @if (modal().hasLikeIcon) {
      <div class="flex justify-between mb-6xl">
        @if (modal().hasLikeIcon) {
          <button
            type="button"
            class="size-12 bg-primary-50 rounded-full flex justify-center items-center">
            <img src="assets/icons/heart/primary.svg" alt="Heart Icon" />
          </button>
        }
      </div>
    }

    @if (modal().title || modal().hasCloseIcon) {
      <div class="flex justify-between mb-2xl items-center">
        @if (modal().title) {
          <h2 class="text-lg font-semibold text-neutral-900">
            {{ modal().title }}
          </h2>
        }

        @if (modal().hasCloseIcon) {
          <button
            (click)="closeModal()"
            class="border border-neutral-200 p-sm rounded-lg cursor-pointer flex">
            <lib-close-icon
              iconClass="size-6"
              stroke="var(--color-neutral-900)" />
          </button>
        }
      </div>
    }

    @if (modal().description) {
      <p class="text-neutral-500">
        {{ modal().description }}
      </p>
    }

    @if (modal() && modal().customizeContent) {
      <ng-container [ngTemplateOutlet]="content()" />
    }
  </div>
</div>

<div
  class="fixed top-0 start-0 w-full h-full bg-black/60 z-[9999]"
  [class.hidden]="!modal().isOpen"
  (click)="!modal().canNotCloseFromOutside && closeModal()"></div>
